import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CmsService from "services/CmsService";

export const fetchCmsData = createAsyncThunk(
  "cms/fetchCmsData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await CmsService.fetchCmsData();
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch CMS data"
      );
    }
  }
);

export const generateCmsPresignedUrl = createAsyncThunk(
  "user/generateCmsPresignedUrl",
  async ({params,data}, { rejectWithValue }) => {
    try {
      const response = await CmsService.generateCmsPresignedUrl(params,data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add user"
      );
    }
  }
);
export const uploadCmsContent = createAsyncThunk(
  "cms/uploadCmsContent",
  async ({ uploadUrl, jsonData }, { rejectWithValue }) => {
    try {
      const response = await CmsService.uploadCmsContent(uploadUrl, jsonData);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to upload content");
    }
  }
);

export const uploadMedia = createAsyncThunk(
  "cms/uploadMedia",
  async ({ uploadUrl, file, }, { rejectWithValue }) => {
    try {
      const response = await CmsService.uploadMedia(uploadUrl, file,);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to upload media");
    }
  }
);
export const deleteMedia = createAsyncThunk(
  "cms/deleteMedia",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CmsService.deleteMedia(data);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to upload media");
    }
  }
);

const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    sections: [],
    fetchStatus: "idle",
    fetchError: null,
    uploadStatus: "idle",
    mediaUploadStatus: "idle",
    mediaDeleteStatus: "idle",
    error: null,
    processing: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearUploadedImages: (state) => {},
    setProcessing: (state, action) => {
      state.processing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCmsData.pending, (state) => {
        state.fetchStatus = "loading";
        state.fetchError = null;
      })
      .addCase(fetchCmsData.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.sections = action.payload?.contentSections || [];
      })
      .addCase(fetchCmsData.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.fetchError = action.payload;
      })
      .addCase(generateCmsPresignedUrl.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(generateCmsPresignedUrl.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
      })
      .addCase(generateCmsPresignedUrl.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload;
      })
      .addCase(uploadCmsContent.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(uploadCmsContent.fulfilled, (state) => {
        state.uploadStatus = "succeeded";
      })
      .addCase(uploadCmsContent.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload;
      })
      .addCase(uploadMedia.pending, (state) => {
        state.mediaUploadStatus = "loading";
        state.error = null;
        state.processing = true;
      })
      .addCase(uploadMedia.fulfilled, (state, action) => {
        state.mediaUploadStatus = "succeeded";
        state.processing = false;
      })
      .addCase(uploadMedia.rejected, (state, action) => {
        state.mediaUploadStatus = "failed";
        state.error = action.payload;
        state.processing = false;
      })
      .addCase(deleteMedia.pending, (state) => {
        state.mediaDeleteStatus = "loading";
        state.error = null;
        state.processing = true;
      })
      .addCase(deleteMedia.fulfilled, (state, action) => {
        state.mediaDeleteStatus = "succeeded";
        state.processing = false;
      })
      .addCase(deleteMedia.rejected, (state, action) => {
        state.mediaDeleteStatus = "failed";
        state.error = action.payload;
        state.processing = false;
      });
  },
});

export const { clearError, clearUploadedImages, setProcessing } =
  cmsSlice.actions;
export default cmsSlice.reducer;
